import { Directive, ElementRef, HostListener, inject, input } from '@angular/core';
import { LogExecutionTime } from '../decorators/mydecorators';

@Directive({
  selector: '[appHighlight]'
})
export class HighlightDirective {
  private element = inject(ElementRef);
  // Se llama igual que la directiva para que se pueda usar como atributo
  appHighlight = input("");
  defaultColor = input("");
  constructor() { 
    //this.element.nativeElement.style.backgroundColor = 'yellow';
  }
  @HostListener('mouseenter') onMouseEnter() {
    this.highlight(this.appHighlight() || this.defaultColor() || 'red');
  }
  @LogExecutionTime('info')
  private highlight(color: string) {
    console.log(`Highlighting with color: ${color} y por defecto ${this.defaultColor()}`);
    this.element.nativeElement.style.backgroundColor = color;
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.highlight('');
  }
}
